{
  "appName": "Apply for apportionment of a beneficiary’s award online",
  "rootUrl": "/forms/21-0788/apply-for-apportionment-beneficiarys-award",
  "entryName": "21-0788",
  "entryFile": "./app-entry.jsx",
  "productId": "",
  "template": {
    "vagovprod": false,
    "layout": "page-react.html",
    "includeBreadcrumbs": false,
    "minimalExcludePaths": ["/introduction", "/confirmation"],
    "minimalFooter": true,
    "minimalHeader": {
      "title": "Apply for apportionment of a beneficiary’s award online",
      "subtitle": "Information Regarding Apportionment of Beneficiary's Award (VA Form 21-0788)"
    }
  }
}